import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = ['source', 'frame']

  connect() {
    if (this.hasSourceTarget) {
      $(this.sourceTarget).on('change', this.refresh)
      this.refresh()
    }
  }

  refresh = () => {
    let query = ''
    for (let option of this.sourceTarget.options) {
      if (option.selected) {
        query += '&' + this.sourceTarget.name + '=' + option.value
      }
    }
    this.frameTarget.src = this.frameTarget.dataset.src + query
  }
}

